// DTOs para creación de partidos del fixture

/**
 * Crea un objeto de partido vacío para el fixture de una etapa
 * @param {Object} contexto - Datos del contexto (torneo, categoría, etapa, etc.)
 * @param {number} idTemporal - ID temporal negativo para identificar el partido antes de grabarlo
 * @param {string} instancia - Código de instancia (U=Único, I=Ida, V=Vuelta)
 * @param {number} indiceCruce - Índice del cruce (0-based) para relacionar partidos de Ida/Vuelta
 * @param {string} zona - Zona del partido (opcional)
 * @param {number} nroFecha - Número de fecha (opcional, para etapas con fechas)
 * @returns {Object} Partido vacío
 */
export const PartidoFixtureVacio = (
  contexto,
  idTemporal,
  instancia,
  indiceCruce,
  zona = null,
  nroFecha = null
) => {
  return {
    // ID temporal negativo para identificar la fila antes de grabar
    idPartido: idTemporal,
    // Índice interno para relacionar partidos de Ida/Vuelta (0-based)
    indiceCruce: indiceCruce,

    // Los campos que se cargarán manualmente
    anioPartido: null,
    mesPartido: null,
    diaPartido: null,
    ordenPartido: null, // Campo opcional, editable por el usuario
    equipoLocal: null,
    equipoVisitante: null,
    zona: zona,

    // Campos del contexto
    codigoCategoria: contexto.categoria?.codigo || null,
    idTorneo: contexto.torneo?.id || null,
    codigoEtapa: contexto.etapa?.etapa?.codigo || null,
    codigoInstancia: instancia,
    nroFecha: nroFecha,

    // Campos que no se cargan en el fixture inicial
    idArbitro: null,
    idEstadio: null,
    neutral: false,
    equipoLibre: false,
    resultadoLocal: null,
    golesLocal: null,
    codigoTipoFormacionLocal: null,
    resultadoVisitante: null,
    golesVisitante: null,
    codigoTipoFormacionVisitante: null,
    idTrofeo: null,
    observaciones: '',
    codigoTipoInternacional: null,
    continuado: false,
    continuacion: false,
    idPartidoOriginal: null,
    consagroCampeon: false,
    sinIncidencias: false,
    anulado: false,
    dudas: '',
  };
};

/**
 * Transforma un partido del fixture al formato esperado por la API (PATCH /partidos/{id})
 * Solo incluye los campos editables en el fixture
 * @param {Object} partido - Partido del fixture
 * @returns {Object} DTO para PATCH
 */
export const PatchPartidoFixture = (partido) => {
  return {
    anioPartido: partido.anioPartido,
    mesPartido: partido.mesPartido,
    diaPartido: partido.diaPartido,
    ordenPartido: partido.ordenPartido ?? null,
    idEquipoLocal: partido.equipoLocal?.id || null,
    idEquipoVisitante: partido.equipoVisitante?.id || null,
  };
};

/**
 * Transforma un partido del fixture al formato esperado por la API (POST /partidos)
 * @param {Object} partido - Partido del fixture
 * @returns {Object} DTO para enviar a la API
 */
export const SavePartidoFixture = (partido) => {
  return {
    anioPartido: partido.anioPartido,
    mesPartido: partido.mesPartido,
    diaPartido: partido.diaPartido,
    codigoCategoria: partido.codigoCategoria,
    idArbitro: partido.idArbitro,
    idEstadio: partido.idEstadio,
    neutral: partido.neutral || false,
    idEquipoLocal: partido.equipoLocal?.id || null,
    equipoLibre: partido.equipoLibre || false,
    resultadoLocal: partido.resultadoLocal,
    golesLocal: partido.golesLocal,
    codigoTipoFormacionLocal: partido.codigoTipoFormacionLocal,
    idEquipoVisitante: partido.equipoVisitante?.id || null,
    resultadoVisitante: partido.resultadoVisitante,
    golesVisitante: partido.golesVisitante,
    codigoTipoFormacionVisitante: partido.codigoTipoFormacionVisitante,
    idTorneo: partido.idTorneo,
    nroFecha: partido.nroFecha,
    codigoInstancia: partido.codigoInstancia,
    ordenPartido: partido.ordenPartido,
    zona: partido.zona,
    codigoEtapa: partido.codigoEtapa,
    idTrofeo: partido.idTrofeo,
    observaciones: partido.observaciones || '',
    codigoTipoInternacional: partido.codigoTipoInternacional,
    continuado: partido.continuado || false,
    continuacion: partido.continuacion || false,
    idPartidoOriginal: partido.idPartidoOriginal,
    consagroCampeon: partido.consagroCampeon || false,
    sinIncidencias: partido.sinIncidencias || false,
    anulado: partido.anulado || false,
    dudas: partido.dudas || '',
  };
};
